module.exports = __webpack_public_path__ + "static/media/微博.a66f2bde.png";